import React from 'react';
export function AffiliateDisclosure() {
  return <div className="space-y-4 text-sm text-slate-600" data-id="element-59">
      <p data-id="element-60">
        Santa's Certified Letter believes in transparency on the web and so we
        are disclosing that we may include certain products and links to those
        products on this site that we will earn an affiliate commission for any
        purchases you make.
      </p>

      <p data-id="element-61">
        Our goal with the site is to help bring joy to children during the
        holiday season, but please understand we are doing this as a for-profit
        business.
      </p>

      <p data-id="element-62">
        You should assume that any links leading you to products or services are
        affiliate links that we will receive compensation from just to be safe.
        Having said that, there are millions of products and services on the web
        that relate to blogging and making money online. We only promote those
        products or services that we have investigated and truly feel deliver
        value to you.
      </p>

      <p data-id="element-63">
        Please note that we have not been given any free products, services or
        anything else by these companies in exchange for mentioning them on the
        site. The only consideration is in the form of affiliate commissions.
      </p>

      <p className="font-medium text-slate-900 mt-4" data-id="element-64">
        If you have any questions regarding the above, please do not hesitate to
        contact us by using the contact page.
      </p>
    </div>;
}